<form class="capa-edit-form" *ngIf="capa" [formGroup]="capaForm" novalidate>


  <mat-form-field class="capa-edit-form--title">
    <input matInput placeholder="Capa Title" 
    formControlName="title" 
    [readonly]="!isNew && canUpdate"/>
    <mat-error *ngIf="capaForm.get('title').hasError('exists')">
      This Capa title already exists in this Finding
    </mat-error>
    <mat-error *ngIf="capaForm.get('title').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="capa-edit-form--due-date">
    <input matInput formControlName="evidenceDueDate" 
        placeholder="Evidence Submission Due Date" 
        [min]="today" 
        [matDatepicker]="dueDateDatePicker" 
        [max]="maxDate"
        [disabled]="canUpdate && !isDraft"
        [readonly]="canUpdate && !isDraft"/>
    <mat-datepicker-toggle matSuffix [for]="dueDateDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #dueDateDatePicker></mat-datepicker>
    <mat-error *ngIf="capaForm.get('evidenceDueDate').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="capa-edit-form--type">
    <mat-select 
    placeholder="CAPA/EC Type" 
    formControlName="capaEcType"
    [disabled]="canUpdate && !isDraft">
      <mat-option *ngFor="let p of capaTypes" [value]="p.key">
        {{ p.text }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="capaForm.get('capaEcType').hasError('required')">
      This field is required
    </mat-error>


  </mat-form-field>

  <div class="capa-edit-form--submission">
      <label id="submission-label">Evidence Submission Rights:</label>

    <mat-radio-group 
    aria-labelledby="submission-label" 
    formControlName="submission" 
    class="capa-edit-form--submission--radio-group"
    [disabled]="canUpdate && !isDraft"
    >
        <mat-radio-button value="1" class="capa-edit-form--submission--radio-button">All CAPA/EC PICs required to submit</mat-radio-button>
        <mat-radio-button value="2" class="capa-edit-form--submission--radio-button">Only one of CAPA/EC PICs required to submit</mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-form-field class="capa-edit-form--pics">
    <mat-select 
    formControlName="pics" 
    placeholder="CAPA/EC PICs"     
    [multiple]="true" 
    #pics>
      <mat-option>

      <ngx-mat-select-search formControlName="picsFilter" [searching]="searching"
      [placeholderLabel]="'Find Employee...'" 
      [noEntriesFoundLabel]="'No employee found'"></ngx-mat-select-search>
      </mat-option>

    <mat-option *ngFor="let emp of filteredPics | async" [value]="emp">
        {{emp.fullName}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="capaForm.get('pics').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="capa-edit-form--description">
    <textarea matInput 
    #description 
    rows="3" 
    placeholder="Finding Description" 
    formControlName="description"
    [readonly]="canUpdate && !isDraft"></textarea>
    <mat-hint align="end">{{ description.value.length || 0 }} / 250</mat-hint>
    <mat-error *ngIf="capaForm.get('description').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

</form>